import { gql } from "@apollo/client"
import { EVENT_FRAGMENT } from "@graphql"

const GET_ME = gql`
  ${EVENT_FRAGMENT}

  query ($clientId: ID!) {
    me {
      id
      name
      email
      isSuperUser
      defaultEvent {
        ...EventFragment
      }
      
      client {
        id
        name
        menu_display_name
        data_age
        imported_at
        mis
        external_ref
        
        importType {
          id
          name
          code
        }
        
        settings {
          id
          unbook_on_non_attendance
          logo_background_color
          phone
          email
          allow_teacher_availability
          allow_teacher_bookings
          allow_teacher_reports
          allow_manual_sb_account_matching
          require_legal_guardian
          is_sb_account_sso
        }

        unassignedStaffMember {
          id
          forename
          surname
          user_id
        }
      }
    }

    auditLogTypes {
      id
      code
      description
    }

    dataCounts(client_id: $clientId) {
      guardian_counts
      lesson_counts
      staff_counts
      student_counts
      subject_counts
      is_complete
    }

    clientUserRoles(client_id: $clientId) {
      id
      admin
      public
      guardian
      staff
      organiser
    }
  }
`

export default GET_ME
